import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DialogService } from 'src/app/core/dialog.service';
import { NavigationService } from 'src/app/core/navigation.service';
import { Order, OrderStatus } from 'src/app/core/orders.service';
import { UtilsService } from 'src/app/core/utils.service';
import { OrdersAmountDialogComponent } from 'src/app/orders/orders-amount-dialog/orders-amount-dialog.component';
import { OrdersDecidoDialogComponent } from 'src/app/orders/orders-decido-dialog/orders-decido-dialog.component';
import { OrdersQineticDialogComponent } from 'src/app/orders/orders-qinetic-dialog/orders-qinetic-dialog.component';
import { OrdersQineticErrorDialogComponent } from 'src/app/orders/orders-qinetic-error-dialog/orders-qinetic-error-dialog.component';
import { STORE_DETAILS_ORDERS_TABLE_COLUMNS } from 'src/app/shared/constants/operationals';

@Component({
  selector: 'app-store-details-order-data-table',
  templateUrl: './store-details-order-data-table.component.html',
  styleUrls: ['./store-details-order-data-table.component.scss'],
})
export class StoreDetailsOrderDataTableComponent {
  @Input() orders: Order[] = [];
  @Output() scrolledToEnd: EventEmitter<void> = new EventEmitter<void>();
  displayed_columns: string[] = STORE_DETAILS_ORDERS_TABLE_COLUMNS;

  constructor(
    private navigation_service: NavigationService,
    private dialog_service: DialogService,
    private utils_service: UtilsService,
  ) {}

  onScroll(event: Event) {
    const element = event.target as HTMLElement;
    const end_offset = 200;
    if (element) {
      if (element.offsetHeight + element.scrollTop >= element.scrollHeight - end_offset) {
        this.scrolledToEnd.emit();
      }
    }
  }

  onQineticClick(order: Order): void {
    this.dialog_service.openDialog(OrdersQineticDialogComponent, {
      qinetic_position_id: order.qinetic_position_id,
      buyer_id: order.buyer_id,
      order_id: order.order_id,
    });
  }

  onPositionErrorClick(order: Order): void {
    this.dialog_service.openDialog(OrdersQineticErrorDialogComponent, { position_error: order.position_error });
  }

  onDecidoClick(order: Order, decido_evaluation_id: string): void {
    this.dialog_service.openDialog(OrdersDecidoDialogComponent, {
      decido_evaluation_id,
      buyer_id: order.buyer_id,
    });
  }

  onOrderAmountClick(order: Order): void {
    const order_amount = order.amount?.total;
    const order_currency = this.getCurrencyLabel(order);
    this.dialog_service.openDialog(OrdersAmountDialogComponent, {
      order_amount,
      order_currency,
      buyer_id: order.buyer_id,
    });
  }

  onOrderDetailClick(store_id: string, order_id: string) {
    this.navigation_service.toOrderDetails(store_id, order_id);
  }

  getEvaluationClass(result: string): string {
    if (result.toUpperCase() == 'DEL-POS') {
      return 'sp-color__green';
    }
    return 'sp-color__red';
  }

  getOrderStatusClass(status: OrderStatus): string {
    return this.utils_service.getOrderStatusClass(status);
  }

  getFullName(order: Order): string {
    return `${order.buyer_firstname} ${order.buyer_lastname}`;
  }

  getCurrencyLabel(order: Order): string {
    return this.utils_service.getCurrencyLabelFromOrder(order);
  }

  getOrderStatusLabel(status?: OrderStatus): string {
    return this.utils_service.getOrderStatusLabel(status);
  }
}
